import { signal } from "@preact-signals/safe-react";

import { WeekStartsOn } from "@pdpp/lib-planta";

// days of the week, 0 = Sunday, 1 = Monday, ..., 6 = Saturday
export const weekStartsOn$ = signal<WeekStartsOn>(1);
